import { render, staticRenderFns } from "./GoToTop.vue?vue&type=template&id=718048ea&scoped=true&"
import script from "./GoToTop.vue?vue&type=script&lang=js&"
export * from "./GoToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718048ea",
  null
  
)

export default component.exports